import * as d3 from 'd3';
import * as React from 'react';

export type TNewWordData = {
  word: string;
  descr: React.ReactElement;
};

export const newWordsData: TNewWordData[] = [
  {
    word: 'стресс',
    descr: (
      <>
        Заимствовано из английского в 1960-е годы, в дневниках начинает активно употребляться в
        1980-е.
      </>
    ),
  },
  {
    word: 'ценник',
    descr: (
      <>
        До второй половины XX века означает «список цен» и почти не встречается вне специальных
        текстов. В дневниках начинает употребляться в 1980-е в значении «этикетка с указанием цены».
        В 2000-е начинает означать «цена» и «общий уровень цен», в Дзене встречается именно в этом
        значении.
      </>
    ),
  },
  {
    word: 'неадекватный',
    descr: (
      <>
        Слово <i>неадекватно</i> встречается уже у Льва Толстого, но до второй половины XX века и
        <i>неадекватный</i>, и <i>неадекватно</i> употребляются редко, в основном в научных текстах.
        В дневниках
        <i>неадекватный</i> начинает активно употребляться с 1970-х. Людей начинают называть
        неадекватными только в XXI веке.
      </>
    ),
  },
  {
    word: 'зашкаливать',
    descr: (
      <>
        Возникает в конце 1950-х и вначале используется только в текстах об измерительных приборах.
        В дневниках появляется в 1980-е и сразу начинает активно употребляться в переносном
        значении.
      </>
    ),
  },
  {
    word: 'пошаговый',
    descr: (
      <>
        В дневниках не встречается вовсе. В Национальном корпусе русского языка употребляется с
        1990-х годов как специальный термин. С начала XXI века — в обычных текстах и блогах (о
        пошаговых планах, руководствах, рецептах).
      </>
    ),
  },
  {
    word: 'везунчик',
    descr: (
      <>
        Возникает в 1950-е годы. Авторы Словаря народных говоров в 1960-е еще затруднялись
        определить значение и приводили такой пример тамбовской загадки: «Везут везунчики, Ползут
        ползунчики, Везут рогатого Колоть косматого (отгадка: лошадь, телега, вилы, сено)». В
        дневниках начинает употребляться начиная с 1980-х.
      </>
    ),
  },
  {
    word: 'неоднозначно',
    descr: (
      <>
        В научных текстах слово употребляется по крайней мере с 1802 года. В дневниках и в
        Национальном корпусе русского языка начинает активно употребляться лишь в 1980-е годы в
        значении эвфемизма, смягченного употребления: <i>относиться неоднозначно</i> на самом деле
        обычно значит ‘относиться плохо’.
      </>
    ),
  },
  {
    word: 'нестабильность',
    descr: (
      <>
        Слово начинает употребляться в конце 1920-х годов в научных контекстах, в основном в области
        физики. В дневниках появляется в 1960-е и с тех пор чаще обсуждается политическая или
        экономическая нестабильность.
      </>
    ),
  },
  {
    word: 'подельник',
    descr: (
      <>
        Слово появляется в самом конце 1960-х. Характерный пример: «Ты же подельник мой. — А что
        такое подельник? — Подельник? Пашка прищурился. Это значит: напарник, товарищ, с которым
        работаешь» (1969). Затем слово распространяется в лагерном жаргоне: «Был осужден не один, а
        вместе с двадцатью двумя моими товарищами, моими подельниками (подельник ― человек,
        осужденный по одному и тому же делу с кем-либо)» [Анатолий Жигулин. Черные камни (1988)]. С
        1970-х годов активно употребляется в значении «сообщник».
      </>
    ),
  },
  {
    word: 'подкаблучник',
    descr: (
      <>
        Появляется в конце 1920-х годов в значении части обуви и вскоре начинает использоваться в
        переносном значении. В дневниках употребляется начиная с 1980-х.
      </>
    ),
  },
  {
    word: 'правдоруб',
    descr: (
      <>
        Появляется в качестве шутки в конце 1980-х и до начала XXI века практически не используется,
        а с 2000-х активно употребляется в газетах. В дневниках не встречается.
      </>
    ),
  },
  {
    word: 'правша',
    descr: (
      <>
        Встречается уже у Даля: «У них один брат правша, другой левша, третий оберуч». Однако с тех
        пор больше ста лет почти не используется. В дневниках почти не встречается. В газетных
        текстах активно употребляется с начале 2000-х.
      </>
    ),
  },
  {
    word: 'силовик',
    descr: (
      <>
        До конца XX века употребляется спорадически («техник-механик (силовик) элеваторно-складского
        хозяйства», 1935, «мастер спорта по боксу и кандидат в мастера по штанге и борьбе, типичный
        силовик», 1971 — в этом значении отмечено в словаре «Новое в русской лексике» в 1978 году).
        С 1999 года начинает активно употребляться в значении чиновника из силовых структур.
      </>
    ),
  },
  {
    word: 'умничка',
    descr: (
      <>
        Появляется в 1970-е (отмечено в словаре «Новое в русской лексике» в 1978 году). В дневниках
        не встречается. В Национальном корпусе русского языка активно используется с 1990-х.
      </>
    ),
  },
  {
    word: 'фокусироваться',
    descr: (
      <>
        До 1980-х употребляется только в оптическом и фотографическом значении, затем начинает
        встречаться в переносном значении «сосредотачиваться».
      </>
    ),
  },
  {
    word: 'шедевральный',
    descr: (
      <>
        Появляется в конце 1980-х (отмечено в словаре «Новое в русской лексике» в 1989 году).
        Возможно, в устной речи встречалось и раньше: «Гениально! Шедеврально!» ― прокричал он
        популярнейшее восклицание своих студенческих пятидесятых и был таков». [Василий Аксенов.
        Новый сладостный стиль (1997)].
      </>
    ),
  },
];

export const newWordsByWord = d3.index(newWordsData, it => it.word);
